/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_OffsetInputs */

const en_timecode_offset = /** @type {(inputs: Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode Offset...`)
};

const fr_timecode_offset = /** @type {(inputs: Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décalage du code temporel...`)
};

const de_timecode_offset = /** @type {(inputs: Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcode-Offset...`)
};

const it_timecode_offset = /** @type {(inputs: Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset del codice temporale...`)
};

const ru_timecode_offset = /** @type {(inputs: Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смещение временного кода...`)
};

const es_timecode_offset = /** @type {(inputs: Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento del código de tiempo...`)
};

const zh_cn2_timecode_offset = /** @type {(inputs: Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码偏移...`)
};

const ja_timecode_offset = /** @type {(inputs: Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコード オフセット...`)
};

const hi_timecode_offset = /** @type {(inputs: Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड ऑफ़सेट...`)
};

const pt_pt2_timecode_offset = /** @type {(inputs: Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocamento do código de tempo...`)
};

/**
* | output |
* | --- |
* | "Timecode Offset..." |
*
* @param {Timecode_OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_offset = /** @type {((inputs?: Timecode_OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timecode_offset(inputs)
	if (locale === "de") return de_timecode_offset(inputs)
	if (locale === "it") return it_timecode_offset(inputs)
	if (locale === "ru") return ru_timecode_offset(inputs)
	if (locale === "es") return es_timecode_offset(inputs)
	if (locale === "zh-CN") return zh_cn2_timecode_offset(inputs)
	if (locale === "ja") return ja_timecode_offset(inputs)
	if (locale === "hi") return hi_timecode_offset(inputs)
	if (locale === "pt-PT") return pt_pt2_timecode_offset(inputs)
	return en_timecode_offset(inputs)
});